import styled from "styled-components"

import { when, minWidth } from "utils"

import CroppedImage from "components/cropped-image"

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 109rem;
  margin: 0 auto;
  padding: 0 2.7rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  > * {
    max-width: 100%;
    flex: 1 0 auto;
  }

  ${minWidth.desktop`
    padding: 0 4rem 4rem;
    flex-direction: row;
    align-items: center;

    > * {
      max-width: 50%;
      flex: 0 0 50%;
    }
  `}
`

export const Left = styled.div`
  padding: 0;

  ${minWidth.desktop`
    padding: 0 4rem;
  `}

  h1 {
    font-weight: 400;
    padding-bottom: 1rem;
    font-size: 2.8rem;
    line-height: 1.26;

    ${minWidth.desktop`
      padding-bottom: 2rem;
      font-size: 3.5rem;
      line-height: 1.2;
    `}
  }

  h3 {
    font-weight: 500;
    margin-bottom: 1.2rem;
    font-size: 1.4rem;
    text-transform: uppercase;
    letter-spacing: 0.2rem;

    &.monoline {
      font-size: 3.2rem;
    }
  }

  > h4 {
    margin-top: 1rem;
    font-weight: 500;
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 1.5;
  }

  ul {
    width: fit-content;
    margin: 1em 0 1em 2rem;
    padding: 0;
  }

  > div > p,
  li {
    font-size: 1.6rem;
    line-height: 1.63;

    ${minWidth.desktop`
      font-size: 1.8rem;
      line-height: 1.56;
    `}
  }
`

export const Right = styled.div`
  position: relative;
  order: 1;
  align-self: stretch;

  ${minWidth.desktop`
    order: auto;
    align-self: auto;

    ${when("reverseOrder")`
      order: -1 !important;
    `}
  `}
`

export const ImageLink = styled.a`
  display: block;
`

export const ImageCropped = styled(CroppedImage)`
  width: 100%;
  padding-top: 100%;
`

export const Caption = styled.div`
  margin-top: 1rem;
  font-size: 1.5rem;
`

export const CreditSource = styled.div`
  margin-top: 0.8rem;
  font-size: 1.5rem;
  font-style: italic;
  color: #767676;
`
